import * as style from '../../utils/general_style.js';

function QuelquesChiffres() {
    const divStyle = {
        ...style.ROW_SPACE_AROUND,
        width: '100%',
        border: '2px solid',
        borderImageSlice: 2,
        borderImageSource : `linear-gradient(180deg, ${style.COLORS.primary}, ${style.COLORS.secondary})`,
        backgroundColor: style.COLORS.white,
        padding: style.SPACE.medium
    };

    const childDiv = {
        width: '33%',
        height: '100%'
    };

	return (
        <div style={divStyle}>
            <div style={childDiv}><p style={{textAlign: 'left'}}><b>+ de 10 partenaires</b><br />Géotechniques en France</p></div>
            <div style={childDiv}><p style={{textAlign: 'center'}}><b>Plus de 30</b><br />Ateliers de sondage</p></div>
            <div style={childDiv}><p style={{textAlign: 'right'}}><b>+ de 700</b><br />Études géotechniques par an</p></div>
        </div>
	);
};

export default QuelquesChiffres;